// react
import React from "react";
// types
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
// config
import { HEADER } from "../../../config";
// types
import type { ReactNode } from "react";

const StyledStack = styled(Stack)(({ theme }) => ({
  flexGrow: 1,
  height: "100%",
  paddingTop: HEADER.MOBILE_HEIGHT + 24,
  paddingBottom: HEADER.MOBILE_HEIGHT + 24,
  margin: "auto",
  [theme.breakpoints.up("lg")]: {
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: HEADER.DASHBOARD_DESKTOP_HEIGHT + 24,
    paddingBottom: HEADER.DASHBOARD_DESKTOP_HEIGHT + 24,
    transition: theme.transitions.create("margin-left", {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

class ErrorBoundary extends React.Component<any, any> {
  constructor(props: { children: ReactNode }) {
    super(props);
    this.state = { hasError: false, error: "" };
  }

  static getDerivedStateFromError(error: any) {
    console.log(error);
    return { hasError: true, error };
  }

  componentDidCatch(error: any, errorInfo: any) {
    this.setState({ hasError: true, error });
  }

  render() {
    if (this.state.hasError) {
      return (
        <StyledStack alignItems={"center"} justifyContent={"center"}>
          <Typography variant={"h1"}>Something went wrong</Typography>
          <Typography variant={"h3"}>
            {this.state?.error?.error?.message}
          </Typography>
        </StyledStack>
      );
      // return <h1>{this.state.error}</h1>;
    }

    return <>{this.props.children}</>;
  }
}

export default ErrorBoundary;
